<template>
  <v-card color="secondary" class="fs-lock">
    <v-card-text class="pt-4">
      <v-alert
        type="error"
        :icon="icons.error"
        outlined
      >
        <div v-if="unverified">
          <strong>Error: {{ error }}</strong><br>
          <span class="white--text">{{ __('unverifiedPayment') }}</span>
        </div>
        <div v-else class="white--text">{{ __('unpaidBlockMessage') }}</div>
      </v-alert>
    </v-card-text>
    <v-card-actions
      v-if="showPaymentLink"
      class="pb-6"
    >
      <v-spacer />
      <v-btn
        depressed
        color="primary"
        @click="proceedToPayment()"
        class="ml-4"
      >
        {{ __('proceedToPayment') }}
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import SblProceedsToPayment from '@/Mixins/SblProceedsToPayment'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      SblProceedsToPayment,
      UsesIcons,
    ],

    props: {
      error: {
        required: false,
        type: String,
        default: '',
      },
    },

    computed: {
      unverified () {
        return !! this.error
      },
    },
  }
</script>

<style lang="scss" scoped>
.fs-lock {
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  padding-top: 12rem;
}
</style>
